import React from 'react';
import styles from '../OrderDetailsModal.module.scss';
import {EditIcon, ExternalLinkIcon, PhoneIcon, PinIcon} from '../icons';
import ButtonWithIcon from 'components/ButtonWithIcon';
import {Link} from 'react-router-dom';
import classNames from 'classnames';

interface Customer {
  name: string;
  phone: string;
  address: string;
  id?: number;
}

interface CustomerInfoProps {
  customer: Customer;
  onEdit?: () => void;
}

const CustomerInfo: React.FC<CustomerInfoProps> = ({customer, onEdit}) => {
  return (
    <div className={classNames(styles.card)}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Customer</h2>
      </div>

      <div className={styles.customerDetails}>
        <div className={styles.customerInfo}>
          <Link
            to={`/people/customers/${customer?.id}/edit`}
            className={styles.customerName}
          >
            <h3 className={styles.customerName}>
              {customer?.name}

              <ExternalLinkIcon className={styles.detailIcon} color="#1A6AE5" />
            </h3>
          </Link>

          <div className={styles.customerDetail}>
            <PhoneIcon className={styles.detailIcon} />
            {customer.phone}
          </div>

          <div className={styles.customerDetail}>
            <PinIcon className={styles.detailIcon} />
            {customer.address}
          </div>
        </div>

        <ButtonWithIcon
          color="ghost"
          size="sm"
          onClick={onEdit}
          icon={<EditIcon className={styles.detailIcon} />}
          iconPosition="left"
          iconSize={16}
        />
      </div>
    </div>
  );
};

export default CustomerInfo;
